<template>
  <app-layout :heading="$t('heading')">
    <v-card>
      <employee-timesheet-editor
        :show-not-saved-warning="true"
        :timesheet-id="timesheetId"
      />
    </v-card>
  </app-layout>
</template>

<script>
import EmployeeTimesheetEditor from '@/components/routes/employees/timesheets/EmployeeTimesheetEditor'

export default {
  components: { EmployeeTimesheetEditor },
  props: ['timesheetId'],
  i18n: {
    messages: {
      de: {
        heading: 'Stundenzettel Übersicht'
      },
      en: {
        heading: 'Timesheet overview'
      },
      ru: {
        heading: 'Обзор табеля'
      },
      tr: {
        heading: 'Zaman çizelgesine genel bakış'
      }
    }
  }
}
</script>
